"use strict";
exports.__esModule = true;
exports.CastNetwork = function (t) { return t; };
